import { BidsHeader } from '../models/bids-header';

export const contactsHeaders: BidsHeader[] = [
  { title: 'Company', SearchItem: 'Company', Size: 3, IsReversed: false, IsDefault: true },
  { title: 'Contact', SearchItem: 'Email', Size: 9, IsReversed: false, IsDefault: false }
];
